<template>
  <BaseInput
    v-if="!showHiddenFeatures"
    v-model="password"
  />
  <PocComponent v-else />
</template>
<script setup lang="ts">
import BaseInput from '@/partners/lingo/lingo-giveaway/components/BaseInput.vue'
import { ref, watch } from 'vue'
import PocComponent from '@/components/PocComponent.vue'
import { showHiddenFeatures } from '@/composables/feature-flag'

function simpleHash(str: string): string {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i)
  }
  return (hash >>> 0).toString(16) // Convert to hexadecimal string
}

const password = ref('')

watch(password, password => {
  if (simpleHash(password) === '4c8a4667') {
    showHiddenFeatures.value = true
  }
})
</script>
